import '../../assets/css/App.css';
import '../../assets/scss/global.scss';

export const modalStyle = {
  display: 'flex',
  flexDirection: 'column',
  minWidth: '300px',
  width: '90vw',
  maxWidth: '800px',
  maxHeight: '93vh',
  overflowY: 'show',
  position: 'fixed',
  paddingTop: '20px',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%,-47%)',
  borderRadius: '5px',
  backgroundColor: '#fff',
};
